var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExperianceSlideBottomRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 69,
    viewBox: "0 0 36 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 45058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 44915"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 890",
    cx: 18.2602,
    cy: 50.807,
    r: 16.9979,
    stroke: "#EDDFF7",
    strokeWidth: 0.829167
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 891",
    cx: 18.2596,
    cy: 50.8065,
    r: 10.7792,
    fill: "#BA7DE9"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line 2",
    x1: 18.6743,
    y1: 0.226562,
    x2: 18.6744,
    y2: 33.3932,
    stroke: "#EDDFF7",
    strokeWidth: 0.829167
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperianceSlideBottomRound);
export default __webpack_public_path__ + "static/media/experiance-slide-bottom-round.1890e5f3cd866fff6523649c8d68fe9e.svg";
export { ForwardRef as ReactComponent };